import React from "react";
import Icons from "../../Icons";

import "./style.scss";

const Preloader = ({isFullscreen}) => {
    return (
        <div className={`c-preloader ${isFullscreen ? '-fullscreen' : ''}`}>
            <div className="c-preloader-icon">
                <Icons name="preloader" />
            </div>
        </div>
    );
};

export default Preloader;